$(function() {
	// Change Users Select
	var $changeUserSelect = $('.change-user-select');
	var $changeUserOwn = $('.change-user-owned input');

	$changeUserSelect.select2({
		width: 'resolve',
		theme: "default amber",
		dropdownAutoWidth : true,
		placeholder: 'Select manager',
		templateResult: function(state) {
			var element = state.element;

			if (!element) {
				return state.text;
			}

			var $text = $('<span />').text(state.text);

			const src = element.dataset.avatar.startsWith('/')
				? element.dataset.avatar 
				: '//www.gravatar.com/avatar/' + element.dataset.avatar;
			var $img = $('<img />')
				.attr('src', src)
				.width(24);

			return $('<div />')
				.css({ 'white-space': 'nowrap' })
				.append($img, $text);
		}
	});

	$changeUserSelect.on('change', function(event) {
		if (event.target.value) {
			var onlyOwnedProject = $changeUserOwn.prop('checked');
			var onlyOwnedParam = '&owned_projects=1';
			var location = event.target.value.replace(onlyOwnedParam, '');

			if (onlyOwnedProject) {
				location += onlyOwnedParam;
			}

			window.location = location;
		}
	});

	$changeUserOwn.on('change', function(event) {
		$changeUserSelect.trigger('change');
	});
});
